<template>
  <div class="wl-mockup">
    <template v-if="$i18n.locale==='ru'">
      <svg-mock-light
        v-if="theme==='light'"
        :title="formatTitle(title)"
        :address="formatAddress(address)"
      />
      <svg-mock-dark
        v-else
        :title="formatTitle(title)"
        :address="formatAddress(address)"
      />
    </template>
    <template v-else>
      <svg-mock-light-eng
        v-if="theme==='light'"
        :title="formatTitle(title)"
        :address="formatAddress(address)"
      />
      <svg-mock-dark-eng
        v-else
        :title="formatTitle(title)"
        :address="formatAddress(address)"
      />
    </template>

    <div class="layer">
      <v-img
        contain
        :src="favicon"
        class="favicon"
      />
      <v-img
        contain
        :src="logo"
        class="logo"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "WhiteLabelMockup",
  components: {
    SvgMockLightEng: () => import("@/views/WhiteLabel/partial/svgMockLightEng.vue"),
    SvgMockDarkEng: () => import("@/views/WhiteLabel/partial/svgMockDarkEng.vue"),
    SvgMockLight: () => import("@/views/WhiteLabel/partial/svgMockLight.vue"),
    SvgMockDark: () => import("@/views/WhiteLabel/partial/svgMockDark.vue"),
  },
  props: {
    theme: {
      type: String,
      default: "light"
    },
    favicon: {
      type: [String, null],
      default: null
    },
    logo: {
      type: [String, null],
      default: null
    },
    title: {
      type: [String, null],
      default: null
    },
    address: {
      type: [String, null],
      default: null
    },
  },
  methods: {
    formatTitle(title) {
      return title
    },
    formatAddress(address) {
      return `https://${address}/dashboard`
    }
  },
}
</script>

<style lang="scss">
:root {
  // Changeable colors
  --light-preview-theme-primary-color: #0059FF;
  --light-preview-theme-secondary-color: #96A2AE;
  --light-preview-theme-primary-text-color: #FFFFFF;
  --dark-preview-theme-primary-color: #0059FF;
  --dark-preview-theme-secondary-color: #96A2AE;
  --dark-preview-theme-primary-text-color: #FFFFFF;
  // Secondary light colors
  --light-preview-theme-surface-color: #2C2D39;
  --light-preview-theme-surface-background: #FFFFFF;
  --light-preview-theme-main-background: #F8F8F8;
  --light-preview-theme-surface-color-70: rgba(49, 57, 44, 0.7);
  --light-preview-theme-surface-color-30: rgba(49, 57, 44, 0.3);
  --light-preview-theme-surface-color-10: rgba(49, 57, 44, 0.1);
  --light-preview-theme-surface-color-03: rgba(49, 57, 44, 0.03);
  --light-preview-theme-surface-background-03: rgba(255, 255, 255, 0.03);
  --light-preview-theme-surface-background-10: rgba(255, 255, 255, 0.1);
  --light-preview-theme-surface-border: rgba(255, 255, 255, 1), rgba(223, 223, 223, 1);
  // Secondary dark colors
  --dark-preview-theme-surface-color: #FFFFFF;
  --dark-preview-theme-surface-background: #2C2D39;
  --dark-preview-theme-main-background: #1C222A;
  --dark-preview-theme-surface-color-70: rgba(255, 255, 255, 0.7);
  --dark-preview-theme-surface-color-30: rgba(255, 255, 255, 0.3);
  --dark-preview-theme-surface-color-10: rgba(255, 255, 255, 0.1);
  --dark-preview-theme-surface-color-03: rgb(0, 10, 221);
  --dark-preview-theme-surface-background-03: rgba(255, 255, 255, 0.03);
  --dark-preview-theme-surface-background-10: rgba(255, 255, 255, 0.1);
  --dark-preview-theme-surface-border: rgba(255, 255, 255, 1), rgba(0, 0, 0, 1);
}
</style>
<style lang="scss" scoped>
.wl-mockup {
  width: 100%;
  height: auto;
  position: relative;

  svg {
    width: 100%;
  }

  .layer {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;

    .favicon {
      position: absolute;
      top: 1.6%;
      left: 6.1%;
      width: 1.23%;
      height: 1.77%;
    }

    .logo {
      position: absolute;
      top: 9.75%;
      left: 3.26%;
      height: 5.55%;
      width: 6.94%;
    }

    .address {
    }
  }
}
</style>